import { useState } from 'react';
import { Trash } from '@drift-labs/icons';
import Tag from 'src/components/primitives/Tag/Tag';
import { useFundingRateAlerts } from './hooks/useFundingRateAlerts';
import {
	ALERT_FREQUENCY_LABELS,
	ALERT_TYPE_LABELS,
	FundingRateAlert,
	MAX_FUNDING_RATE_ALERTS,
} from './types';
import DeleteAlertModal from './DeleteAlertModal';

export default function FundingRateAlertList() {
	const { alerts, deleteAlert } = useFundingRateAlerts();
	const [alertToDelete, setAlertToDelete] = useState<FundingRateAlert | null>(
		null
	);

	const handleConfirmDelete = () => {
		if (alertToDelete) {
			deleteAlert(alertToDelete.id);
			setAlertToDelete(null);
		}
	};

	return (
		<>
			<div className="flex flex-1 flex-col gap-lg overflow-y-auto">
				{alerts.length === 0 ? (
					<div className="flex flex-1 items-center justify-center">
						<p className="typo-b4 text-text-tertiary">No alerts created yet</p>
					</div>
				) : (
					alerts.map((alert) => (
						<AlertCard
							key={alert.id}
							alert={alert}
							onDelete={() => setAlertToDelete(alert)}
						/>
					))
				)}
			</div>

			<DeleteAlertModal
				open={!!alertToDelete}
				onClose={() => setAlertToDelete(null)}
				onConfirm={handleConfirmDelete}
			/>
		</>
	);
}

export function FundingRateAlertListTitle({
	alertCount,
}: {
	alertCount: number;
}) {
	return (
		<>
			Funding Rate Alert {alertCount}/{MAX_FUNDING_RATE_ALERTS}
		</>
	);
}

function AlertCard({
	alert,
	onDelete,
}: {
	alert: FundingRateAlert;
	onDelete: () => void;
}) {
	const alertTypeLabel = ALERT_TYPE_LABELS[alert.alertType];

	return (
		<div className="group flex items-center gap-lg rounded-sm bg-button-disabled px-lg py-md">
			<div className="flex flex-1 flex-col gap-sm">
				<span className="typo-t3 text-text-default">
					{alert.marketSymbol} — {alertTypeLabel} {alert.thresholdPercent}%
				</span>
				<Tag className="bg-button-secondary-bg-hover text-text-default">
					{ALERT_FREQUENCY_LABELS[alert.frequency]}
				</Tag>
			</div>
			<button
				className="opacity-0 transition-opacity group-hover:opacity-100"
				onClick={onDelete}
			>
				<Trash size={18} />
			</button>
		</div>
	);
}
